import React from 'react'
import Button from '../button/Button'
import { VerifyAchCardActions, VerifyAchCardContainer, VerifyAchCardContent, VerifyAchCardOlItem, VerifyAchCardOlList, VerifyAchCardText, VerifyAchCardTitle } from './Theme'

const VerifyAchCardInfo = ({
  closeModal,
}) => {
  return (
    <VerifyAchCardContainer>
      <VerifyAchCardTitle>Verify Your ACH Account</VerifyAchCardTitle>
      <VerifyAchCardContent>
        <VerifyAchCardText>
          To complete the verification, check your bank statement for two small deposit amounts sent by us.
        </VerifyAchCardText>
        <div>
          <VerifyAchCardText>Once you have the values:</VerifyAchCardText>
          <VerifyAchCardOlList>
            <VerifyAchCardOlItem>Locate the deposits (usually within 1–2 business days).</VerifyAchCardOlItem>
            <VerifyAchCardOlItem>Enter the exact amounts in the fields provided.</VerifyAchCardOlItem>
          </VerifyAchCardOlList>
        </div>
        <VerifyAchCardText>
          Thank you for verifying your account!
        </VerifyAchCardText>
      </VerifyAchCardContent>
      <VerifyAchCardActions>
        <Button
          onClick={closeModal}
          variant="primary"
          size="md"
          style={{
            minWidth: 80,
          }}
        >
          <span>Ok</span>
        </Button>
      </VerifyAchCardActions>
    </VerifyAchCardContainer>
  )
}

export default VerifyAchCardInfo